import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Page, Tabs } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { BannedIpsTab } from './bannedIpsComponents/bannedIpsTab';
import { BannedUsersTab } from './bannedUsersComponents/bannedUsersTab';
var BanTabs;
(function (BanTabs) {
    BanTabs["UserBansTab"] = "Users";
    BanTabs["IPBansTab"] = "IP addresses";
})(BanTabs || (BanTabs = {}));
const tabsDefinition = Object.values(BanTabs).map((tabName) => ({
    id: tabName,
    label: tabName,
}));
export function Bans() {
    const [activeTab, setActiveTab] = useState(BanTabs.UserBansTab);
    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Page.Tabs, { children: _jsx(Tabs, { selectedId: activeTab, tabs: tabsDefinition, onChange: handleTabChange }) }), _jsxs(Page.Body, { children: [activeTab === BanTabs.UserBansTab && _jsx(BannedUsersTab, {}), activeTab === BanTabs.IPBansTab && _jsx(BannedIpsTab, {})] })] }));
}
